import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import PageTemplate from 'components/page-template'
import Experience from './experience'
import StatusFilter from './status-filter'
import NameOrTypeSearch from './name-or-type-search'

import './my-experiences.css'

const MyExperiencesComponent = ({
  onFilter,
  onSearch,
  onStatusUpdate,
  experiences,
  activeExperienceCount,
  canCreate,
  getParticipants,
  participantsLoaded
}) => (
  <PageTemplate
    title='My Experiences'
    description='browse my experiences'
    className='br-user-experiences'
    noContainer
  >
    {/* Experience filter */}
    <div className='portlet light'>
      <div className='row'>
        <div className='br-experience-head col-md-12'>
          <span className='font-blue-sharp bold uppercase'>
            {activeExperienceCount === 0
              ? 'You have no active experiences'
              : `You have ${activeExperienceCount} active ${
                  activeExperienceCount === 1 ? 'experience' : 'experiences'
                }`}
          </span>
          <div style={{ display: 'flex', flexFlow: 'row nowrap', gap: '1rem' }}>
            <button
              className='btn green-haze'
              onClick={getParticipants}
              disabled={
                !experiences || !experiences.length || participantsLoaded
              }
            >
              <i
                className={`fa ${participantsLoaded ? 'fa-check' : 'fa-users'}`}
              />
              Load Participants
            </button>

            {canCreate ? (
              <Link to={`/explore-experiences`} className='btn green-haze'>
                <i className='fa fa-plus' />
                Create Experience
              </Link>
            ) : null}
          </div>
        </div>
      </div>

      <hr />

      <div className='row'>
        <div className='col-xs-12 col-sm-6 col-md-4'>
          <StatusFilter onFilter={onFilter} />
        </div>
        <div className='col-xs-12 col-sm-6 col-md-offset-4 col-md-4'>
          <NameOrTypeSearch onSearch={onSearch} />
        </div>
      </div>
    </div>

    {/* List of experiences */}
    <div className='activeWidgets row'>
      {experiences.map(experience => (
        <Experience
          key={experience.id}
          {...experience}
          onStatusUpdate={onStatusUpdate}
          canCreate={canCreate}
          participantCount={experience.participants.length || 0}
        />
      ))}
    </div>
  </PageTemplate>
)

MyExperiencesComponent.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onFilter: PropTypes.func.isRequired,
  onStatusUpdate: PropTypes.func.isRequired,
  getParticipants: PropTypes.func.isRequired,
  experiences: PropTypes.array.isRequired,
  activeExperienceCount: PropTypes.number.isRequired,
  participantsLoaded: PropTypes.bool.isRequired,
  canCreate: PropTypes.bool.isRequired
}

MyExperiencesComponent.displayName = 'MyExperiencesComponent'

export default MyExperiencesComponent



// WEBPACK FOOTER //
// ./src/pages/my-experiences/my-experiences.js